import React from "react";
import { Dropdown } from "@hid-galaxy-ui/galaxy-react";
import {
  AdminHomeDropdownOption,
  adminHomeDropdownMenuPortalTarget,
  adminHomeSingleDropdownStyles,
} from "../../utils/adminHomeDropdownStyles";
import type { AdminHomeFilterOptionGroup } from "../../utils/filterOptions";
import { PartnerEcosystemGridIcon } from "../shared/adminHomeIcons";
import AdminHomeFilterDropdown from "./AdminHomeFilterDropdown";
import "../../../../pages/hid-admin/create-new-partner/partner-detail-form/PartnerDetailForm.scss";

type ActionItemsToolbarProps = {
  basedOnOptions: AdminHomeDropdownOption[];
  filterOptionGroups: AdminHomeFilterOptionGroup[];
  isFilterEnabled: boolean;
  basedOn: AdminHomeDropdownOption | null;
  filters: AdminHomeDropdownOption[];
  onBasedOnChange: (option: AdminHomeDropdownOption | null) => void;
  onFiltersChange: (options: AdminHomeDropdownOption[]) => void;
};

const ActionItemsToolbar: React.FC<ActionItemsToolbarProps> = ({
  basedOnOptions,
  filterOptionGroups,
  isFilterEnabled,
  basedOn,
  filters,
  onBasedOnChange,
  onFiltersChange,
}) => {
  return (
    <div className="admin-home-action-toolbar">
      <div className="admin-home-action-toolbar__title-block">
        <span className="admin-home-action-toolbar__icon">
          <PartnerEcosystemGridIcon width={24} height={24} />
        </span>
        <div className="admin-home-action-toolbar__text">
          <h2 className="admin-home-action-toolbar__title">Action Items</h2>
          <p className="admin-home-action-toolbar__subtitle">
            Add new partner details
          </p>
        </div>
      </div>

      <div className="admin-home-action-toolbar__filters partner-detail-form-container partner-detail-form-container--modal">
        <div className="label-field-container admin-home-action-toolbar__filter-field">
          <label className="field-label" htmlFor="admin-home-based-on">
            Based On
          </label>
          <Dropdown
            label=""
            id="admin-home-based-on"
            placeholder="Select"
            theme="dark"
            options={basedOnOptions}
            selected={basedOn}
            onSelect={(data) =>
              onBasedOnChange((data as AdminHomeDropdownOption | null) ?? null)
            }
            menuPortalTarget={adminHomeDropdownMenuPortalTarget}
            styles={adminHomeSingleDropdownStyles}
          />
        </div>

        <div className="label-field-container admin-home-action-toolbar__filter-field admin-home-action-toolbar__filter-field--wide">
          <label className="field-label" htmlFor="admin-home-filter">
            Filter
          </label>
          <AdminHomeFilterDropdown
            filterOptionGroups={filterOptionGroups}
            filters={filters}
            basedOnValue={basedOn?.value ?? null}
            isDisabled={!isFilterEnabled}
            onFiltersChange={onFiltersChange}
          />
        </div>
      </div>
    </div>
  );
};

export default ActionItemsToolbar;
